import React from "react";
import type { Position } from ".";
import { CORNER_RADIUS } from "./constants";

export const GenomesTreeEdge = ({
  p0,
  p1,
  muted = false,
}: {
  p0: Position;
  p1: Position;
  muted?: boolean;
}) => {
  return (
    <path
      d={[
        `M ${p0[0]} ${p0[1]}`,
        `L ${p0[0]} ${p1[1] - CORNER_RADIUS}`,
        `Q ${p0[0]} ${p1[1]}, ${p0[0] + CORNER_RADIUS} ${p1[1]}`,
        `L ${p1[0]} ${p1[1]}`,
      ].join(" ")}
      strokeLinejoin="round"
      className={"genomes-tree__nodes__edge" + (muted ? " genomes-tree__nodes__edge--muted" : "")}
    />
  );
};
